import { render, staticRenderFns } from "./TwilioChat.vue?vue&type=template&id=63b9fdd0&scoped=true&"
import script from "./TwilioChat.vue?vue&type=script&lang=js&"
export * from "./TwilioChat.vue?vue&type=script&lang=js&"
import style0 from "./TwilioChat.vue?vue&type=style&index=0&id=63b9fdd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b9fdd0",
  null
  
)

export default component.exports